import type { PromoRejection, ReferralRejection } from "@/lib/referrals/attribution"
import { MarketplaceErrorCode } from "@/lib/utils/marketplace-errors"
import { errorCode, marketplaceErrorBody } from "@/platform/api/errors"
import { REFERRAL_ERROR_CODES } from "@/platform/api/referrals"

export type PromoOutcome = { kind: "rejected"; reason: PromoRejection } | { kind: "transient" }

const REJECTION_BY_CODE: Record<string, PromoRejection> = {
  [REFERRAL_ERROR_CODES.alreadyPurchased]: "alreadyPurchased",
  [REFERRAL_ERROR_CODES.existingLoans]: "existingLoans",
  [REFERRAL_ERROR_CODES.usageLimitReached]: "alreadyRedeemed",
  [REFERRAL_ERROR_CODES.selfReferral]: "selfReferral",
  [REFERRAL_ERROR_CODES.offerUnavailable]: "offerUnavailable",
  [REFERRAL_ERROR_CODES.notAvailable]: "notAvailable",
  [REFERRAL_ERROR_CODES.discountNotFound]: "notFound",
  [REFERRAL_ERROR_CODES.discountNotValid]: "generic",
  [REFERRAL_ERROR_CODES.discountBelowMinimum]: "generic",
  [REFERRAL_ERROR_CODES.discountNoEligibleItems]: "generic",
}

const REJECTION_BY_INVALIDATION: Record<string, PromoRejection> = {
  self_referral: "selfReferral",
  offer_unavailable: "offerUnavailable",
  already_purchased: "alreadyPurchased",
  existing_loans: "existingLoans",
}

export const droppedCodeFromError = (error: unknown): ReferralRejection | null => {
  const [invalidation] = marketplaceErrorBody(error, MarketplaceErrorCode.CartDiscountsInvalidated)?.details?.invalidations ?? []
  return invalidation ? { code: invalidation.code, reason: REJECTION_BY_INVALIDATION[invalidation.reason] ?? "generic", dropped: true } : null
}

export const promoOutcomeFromError = (error: unknown): PromoOutcome => {
  const code = errorCode(error)
  const mapped = code ? REJECTION_BY_CODE[code] : undefined
  return mapped ? { kind: "rejected", reason: mapped } : { kind: "transient" }
}
